import { DownloadDoc } from "@portal/BaseComponents/Document/DownloadDoc/DownloadDoc";
import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { DocumentList } from "@portal/types/entities/documents";
import { CellRenderProps } from "@sinecycle/growcomponents";
import { Delete } from "./Delete/Delete";
import { Preview } from "./Preview/Preview";

function Actions(props: CellRenderProps<DocumentList>) {
  const { data } = props;
  if (!data) return;
  const Download = (
    <DownloadDoc
      id={data.attachment.id}
      name={data.attachment.file_name}
      buttonProps={{ size: "middle" }}
    />
  );
  const PreviewDoc = <Preview attachment={data.attachment} />;
  const DeleteDoc = <Delete id={data.id} />;
  return (
    <Flex
      align="center"
      justify="flex-end"
      style={{ width: "100%", height: "100%" }}
      space='8'
    >
      {Download}
      {DeleteDoc}
      {PreviewDoc}
    </Flex>
  );
}

export { Actions };
